import React, { useState } from 'react'
import { makeStyles } from '@mui/styles'

import lang from '@/lang'
import AddSvg from '@assets/images/icons/add.svg'
import AttachmentSvg from '@assets/images/icons/attachment.svg'
import UploadSvg from '@assets/images/icons/picture_upload.svg'
import { SpeedDial, SpeedDialAction } from '@/modules/base/components/speed-dial'
import ReceiptUploadAction from '@/components/controls/file-actions-speed-dial/receipt-upload-action'
import { useSelector } from 'react-redux'
import { USER_RIGHTS, ProductTypes } from '@/modules/base/util/constants'
import StartTrialModal from '@/modules/moduleSubscription/components/start-trial-modal'
import { FineUploader } from 'fine-uploader'
import { checkAccessRights } from '@/modules'
import { useUpgradeModal } from '@/hooks/useUpgradeModal'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'center',

    '& > *': {
      marginBottom: 8,

      '&:last-child': {
        marginBottom: 0,
      },
    },
  },
}))

type FileActionsSpeedDialPropTypes = {
  uploader: FineUploader,
  acceptAttribute: string,
  openFileContainer: (event: MouseEvent) => void,
  /** FLAG:useDocuAi — T25: route the upload action through DMS→DocuAI (see ReceiptUploadAction). */
  useDmsUpload?: boolean,
  onDmsUpload?: (files: File[]) => void,
}

const FileActionsSpeedDial = (props: FileActionsSpeedDialPropTypes) => {
  const classes = useStyles()
  const openUpgradeModal = useUpgradeModal()
  const { uploader, acceptAttribute, openFileContainer, useDmsUpload, onDmsUpload } = props
  const [openTrialModal, setOpenTrialModal] = useState(false)
  const subscriptions = useSelector(state => state.subscription.details.subscriptions)
  const userInfo = useSelector(state => state.user.info)
  const documentSub = subscriptions.find((subscription) => subscription.typeOfSubscription === ProductTypes.DOCUMENT)
  const hasAccess = checkAccessRights(USER_RIGHTS.DOCUMENTS.READ, userInfo)

  const onOpenContainer = (event): void => {
    if (!documentSub && !hasAccess) {
      return setOpenTrialModal(true)
    } else if (!hasAccess && documentSub?.isExpired) {
      return openUpgradeModal({ subscriptionType: ProductTypes.DOCUMENT })
    }

    openFileContainer?.(event)
  }

  return (
    <>
      <div className={classes.root}>
        <SpeedDial
          icon={AddSvg}>
          {(userInfo.isOwner || hasAccess) && (
            <SpeedDialAction
              label={lang.expense.receipt.openDocumentContainer}
              icon={AttachmentSvg}
              onClick={onOpenContainer} />
          )}
          <ReceiptUploadAction
            label={lang.expense.receipt.upload}
            icon={UploadSvg}
            accept={acceptAttribute}
            uploader={uploader}
            useDmsUpload={useDmsUpload}
            onDmsUpload={onDmsUpload}
          />
        </SpeedDial>
      </div>
      <StartTrialModal
        open={openTrialModal}
        productType={ProductTypes.DOCUMENT}
        onClose={() => setOpenTrialModal(false)} />
    </>
  )
}

export default FileActionsSpeedDial
